// extracted by mini-css-extract-plugin
export default {"container":"container__Notification__9pBLP"};